import { Line } from "../../models/shapes/Line";
import { Point } from "../../models/Point";
import { s } from "../globalState/settings";

/**
 * Factory functions for creating common line patterns
 */

/**
 * Creates a line with default tee color and block thickness
 */
export function createDefaultLine(): Line {
    return new Line(Point.ORIGIN, Point.ORIGIN, s.teeColor, s.blockThickness);
}

/**
 * Creates multiple default lines
 */
export function createDefaultLines(count: number): Line[] {
    return Array.from({ length: count }, () => createDefaultLine());
}

/**
 * Creates lines for Tee resistance (5 lines)
 */
export function createTeeLines(): Line[] {
    return createDefaultLines(5);
}

/**
 * Creates lines for ElbowBlock resistance (4 lines)
 */
export function createElbowBlockLines(): Line[] {
    return createDefaultLines(4);
}

/**
 * Creates a line with specific color and thickness
 */
export function createCustomLine(color: number[], thickness: number): Line {
    return new Line(Point.ORIGIN, Point.ORIGIN, color, thickness);
}

/**
 * Creates multiple custom lines
 */
export function createCustomLines(count: number, color: number[], thickness: number): Line[] {
    return Array.from({ length: count }, () => createCustomLine(color, thickness));
}
